export default __webpack_public_path__ + "static/media/28.b435509a.jpg";